<template>
  <avs-card>
    <template v-slot:title>
      <v-card-title class="pl-0">{{ $t("commons.department") }}</v-card-title>
    </template>
    <template v-slot:content>
      <v-container>
        <v-form
          :readonly="!isEditable"
          ref="form"
        >
          <v-text-field
            v-model="department.name"
            :rules="rules.name"
            :label="$t('commons.name')"
            counter="64"
            maxlength="64"
            outlined
            dense
          ></v-text-field>

          <v-textarea
            v-model="department.description"
            :rules="rules.description"
            :label="$t('commons.description')"
            outlined
            dense
          ></v-textarea>

          <v-col class="d-flex justify-end gap-4">
            <avs-saveButton
              @click="save"
              :disabled="!isEditable"
            />
            <avs-cancelButton @click="cancel" />
          </v-col>
        </v-form>
      </v-container>
    </template>
  </avs-card>
</template>

<script>
import { DepartmentService } from "@/services"
import { isEqual } from "@/utils/object"
import { required, slug, max64 } from "@/utils/validator"

import _ from "lodash"

export default {
  name: "ChatIA",
  props: {
    hasUniqueName: {
      type: Function,
      required: true
    },
    isEditable: {
      type: Boolean,
      default: true
    },
    value: {
      type: Object
    }
  },
  computed: {
    department: {
      get() {
        return _.cloneDeep(this.value || this.getDefaultValue())
      }
    },
    company() {
      return this.$store.state.app.company
    }
  },
  data() {
    return {
      rules: {
        description: [],
        code: [required, slug, max64],
        name: [required, max64]
      },
      nameField: null
    }
  },
  created() {},
  methods: {
    getDefaultValue() {
      return {
        name: "",
        description: ""
      }
    },
    cancel() {
      this.$emit("cancel")
    },
    async performSave(data) {
      if (data.id > 0) {
        return DepartmentService.put(data)
      } else {
        return DepartmentService.post(this, this.company.pk, data)
      }
    },
    async save() {
      if (this.$refs.form.validate()) {
        if (isEqual(this.department, this.value)) {
          // Objects are equal, no changes to perform
          this.$emit("success")
        } else {
          this.performSave(this.department)
            .then(response => {
              this.$emit("input", response)
              this.$emit("success")
            })
            .catch(error => {
              const message = error.message
              this.$emit("error", message)
            })
        }
      }
    }
  }
}
</script>
